export { default as ResponsiveRadialBar } from './dist/ResponsiveRadialBar.js';
